import React from 'react';
import { X } from 'lucide-react';
import { CustomerInfo } from './publicMenuTypes';

type Props = {
  open: boolean;
  tableNumber: string | undefined;
  customerInfo: CustomerInfo;
  onClose: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
};

const PublicMenuCustomerModal: React.FC<Props> = ({
  open,
  tableNumber,
  customerInfo,
  onClose,
  onChange,
  onSubmit,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md rounded-xl bg-white shadow-xl">
        <div className="p-5">
          <div className="mb-4 flex items-center justify-between">
            <h2 className="text-lg font-semibold text-zinc-900">Table {tableNumber}</h2>
            <button type="button" onClick={onClose} className="rounded-lg p-1 text-zinc-400 hover:bg-zinc-100 hover:text-zinc-600">
              <X className="h-5 w-5" />
            </button>
          </div>

          <p className="mb-4 text-sm text-zinc-600">Enter your name to start ordering (optional phone).</p>

          <form onSubmit={onSubmit} className="space-y-3">
            <div>
              <label className="mb-1 block text-xs font-medium text-zinc-700">Your name *</label>
              <input
                type="text"
                name="name"
                value={customerInfo.name}
                onChange={onChange}
                className="w-full rounded-lg border border-zinc-200 px-3 py-2 text-sm focus:border-amber-500 focus:outline-none focus:ring-2 focus:ring-amber-100"
                placeholder="Your name"
                required
              />
            </div>
            <div>
              <label className="mb-1 block text-xs font-medium text-zinc-700">Phone (optional)</label>
              <input
                type="tel"
                name="phone"
                value={customerInfo.phone}
                onChange={onChange}
                className="w-full rounded-lg border border-zinc-200 px-3 py-2 text-sm focus:border-amber-500 focus:outline-none focus:ring-2 focus:ring-amber-100"
                placeholder="Phone"
              />
            </div>
            <div className="flex gap-2 pt-2">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 rounded-lg bg-zinc-100 py-2.5 text-sm font-medium text-zinc-700 hover:bg-zinc-200"
              >
                Skip
              </button>
              <button type="submit" className="flex-1 rounded-lg bg-amber-600 py-2.5 text-sm font-semibold text-white hover:bg-amber-700">
                Continue
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PublicMenuCustomerModal;
